import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import WidgetReservationsApi from '../generated/api/WidgetReservations';

export default (service: Servicelayer) => ({
  ...WidgetReservationsApi(service),

  // Add custom calls here

});
